/* eslint-disable import/extensions */
import htmllistitem from './projects/views/project-details-item.ktmpl.html';
import htmltabs from './views/tabs.tmpl.html';
import {BrsBaseWidget} from './base';
import {BrsPlasticProjectsDashboardWidget} from './projects/pdashboard';
import {BrsInventoryDashboard} from './inventories/idashboard';
import {BrsPlasticProjectWidget} from './projects/project';
import {BrsInventory} from './inventories/inventory';

BrsBaseWidget.registerBrsWidget(BrsPlasticProjectsDashboardWidget);
BrsBaseWidget.registerBrsWidget(BrsPlasticProjectWidget);
BrsBaseWidget.registerBrsWidget(BrsInventory);
BrsBaseWidget.registerBrsWidget(BrsInventoryDashboard);

export type BrsPlasticAppOptions = {
	resourceUrl: string;
};

export class BrsPlasticAppWidget extends BrsBaseWidget {
	declare public woptions: BrsPlasticAppOptions;
	constructor(selector: Element, woptions?: BrsPlasticAppOptions) {
		super(selector, woptions);
		this.woptions = {
			resourceUrl: '',
			...woptions,
			...$(selector).data(),
		};

		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		this.onInit();
	}

	async onInit() {
		const router = new kendo.Router();
		router.route('/', () => {
			this.initTabs();
		});

		router.route('/project/:id', (id: string) => {
			$(this.element).kendoBrsPlasticProjectWidget(
				{
					project: id,
					template: htmllistitem,
					resourceUrl: this.woptions.resourceUrl,
				},
			);
		});
		router.route('/inventory/:id', (id: string) => {
			$(this.element).kendoBrsInventory(
				{
					inventory: id,
					isFull: true,
					resourceUrl: this.woptions.resourceUrl,
				},
			);
		});
		router.start();
	}

	initTabs() {
		$(this.element).html(htmltabs);
		const tabStrip = $('#brs-tabstrip', this.element).kendoTabStrip({
			animation: {
				open: {
					effects: 'fadeIn',
				},
			},
			select: this.onSelectTab.bind(this),
		});
		tabStrip?.data('kendoTabStrip')?.select(0);

		// Get the URL parameters
		const urlParameters = new URLSearchParams(window.location.search);

		// Check if the "i" parameter is not present
		if (!urlParameters.has('i')) {
			// Remove the tab if the "i" parameter is not present
			tabStrip?.data('kendoTabStrip')?.remove(1);
		}
	}

	async onSelectTab(event: kendo.ui.TabStripSelectEvent) {
		if (!event.item) {
			return;
		}

		const result = await fetch(`${this.woptions.resourceUrl}/ungeojson.json`);
		const geojson = await result.json() as GeoJSON.FeatureCollection;

		const selectedIndex = $(event.item).index();
		if (selectedIndex === 0) {
			// eslint-disable-next-line @typescript-eslint/no-floating-promises
			this.loadProjects(geojson);
		} else if (selectedIndex === 1) {
			// eslint-disable-next-line @typescript-eslint/no-floating-promises
			this.loadInventory(geojson);
		}
	}

	async loadProjects(geojson: GeoJSON.FeatureCollection) {
		const element = $('#brs-projects-content', this.element);
		if (element.data('kendoBrsPlasticProjectsDashboardWidget') !== undefined) {
			return;
		}

		element.kendoBrsPlasticProjectsDashboardWidget({geojson, resourceUrl: this.woptions.resourceUrl});
	}

	async loadInventory(geojson: GeoJSON.FeatureCollection) {
		const element = $('#brs-inventory-content', this.element);
		if (element.data('kendoBrsInventoryDashboard') !== undefined) {
			return;
		}

		element.kendoBrsInventoryDashboard({geojson, resourceUrl: this.woptions.resourceUrl});
	}
}

declare global {
	// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
	interface JQuery {
		kendoBrsPlasticAppWidget(options?: BrsPlasticAppOptions): JQuery;
		data(widgetName: 'kendoBrsPlasticAppWidget'): BrsPlasticAppWidget;
	}
}

BrsBaseWidget.registerBrsWidget(BrsPlasticAppWidget);
